
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20 10c0-5.512-4.488-10-10-10S0 4.488 0 10s4.488 10 10 10 10-4.488 10-10zM1.6 10c0-4.628 3.772-8.4 8.4-8.4s8.4 3.772 8.4 8.4-3.772 8.4-8.4 8.4-8.4-3.772-8.4-8.4zm7.474-5.556v1.852h1.852V4.444H9.074zm0 10.186V8.148h1.852v6.482H9.074z","fill":"#517BA6"}})])
          )
        }
      }
    